import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, DEFAULT_IMG, absoluteImage } from "@/lib/seo";

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  lang = "fr",
  type = "website",
  noindex = false,
  jsonLd = null,
}) {
  const url = `${SITE_URL}${path}`;
  const ogLocale = lang === "en" ? "en_GB" : "fr_FR";
  const imageUrl = absoluteImage(image);
  const blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : jsonLd ? [jsonLd] : [];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large"} />
      <meta property="og:site_name" content="HORS SIGNAL" />
      <meta property="og:type" content={type} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
